module.exports = __webpack_public_path__ + "img/advantage5.e4f64727.png";